import { useAuth } from '@/hooks/useAuth';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Lock } from 'lucide-react';

export function SessionExpiredModal() {
  const { sessionExpired } = useAuth();

  const handleLogin = () => {
    window.location.href = '/login';
  };

  // Suppress on /reset-password — that page shows its own branded success screen
  // instructing users to return to the PodBrief mobile app.
  if (typeof window !== 'undefined' && window.location.pathname === '/reset-password') {
    return null;
  }

  return (
    <Dialog open={sessionExpired}>
      <DialogContent 
        className="sm:max-w-md"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader className="text-center sm:text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-muted">
            <Lock className="h-6 w-6 text-muted-foreground" />
          </div>
          <DialogTitle>Your session has expired</DialogTitle>
          <DialogDescription>
            For your security, you've been logged out. Please sign in again to continue.
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-center mt-4">
          <Button onClick={handleLogin} className="w-full sm:w-auto">
            Log in again
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
